import React from 'react';
import { createPortal } from 'react-dom';
import * as Sentry from '@sentry/react';
import { FavoriteRecreationResponse } from '@/types';
import { fetchFavoriteRecreations } from '@/infrastructure';
import { FacilityFavoriteRecreation } from '../index';

type Props = {
  elements: Element[];
};

export const FacilityFavoriteRecreationList: React.FC<Props> = ({ elements }) => {
  const [statuses, setStatuses] = React.useState<FavoriteRecreationResponse[] | null>(null);
  // elements は毎レンダー同じ内容だが参照が変わるため、id 配列を安定させてから依存に入れる
  const recreationIds = React.useMemo(
    () => elements.map((elm) => parseInt(elm.id.replace('favoriteIcon_', ''), 10)),
    [elements]
  );

  React.useEffect(() => {
    const load = async (): Promise<void> => {
      try {
        const data = await fetchFavoriteRecreations(recreationIds);
        setStatuses(data);
      } catch (e) {
        Sentry.captureException(e);
      }
    };
    load();
  }, [recreationIds]);

  if (statuses === null) return null;

  return (
    <>
      {elements.map((elm) => {
        const id = parseInt(elm.id.replace('favoriteIcon_', ''), 10);
        const favoriteId = statuses.find((status) => status.recreationId === id)?.id ?? null;
        return createPortal(
          <FacilityFavoriteRecreation
            recreationId={id}
            initialIsFavorite={favoriteId !== null}
            initialFavoriteId={favoriteId}
          />,
          elm
        );
      })}
    </>
  );
};
